import React from 'react';
import { Tag } from 'antd';
import { ShipmentCommercialInvoiceDetailStatus } from '@xbcb/shipment-types';
import { safeGetMessage } from '@xbcb/ui-utils';
import { useBundle } from '@amzn/react-arb-tools';

export interface ShipmentStatusProps {
  status?: ShipmentCommercialInvoiceDetailStatus;
}

const ShipmentStatus: React.FC<ShipmentStatusProps> = ({ status }) => {
  const [bundle] = useBundle('components.ShipmentStatus');
  const validationFailedMessage = safeGetMessage(
    bundle,
    'shipment_validation_failed',
    {},
    'Seller Documents Rejected',
  );

  const inProgressMessage = safeGetMessage(
    bundle,
    'shipment_application_in_progress',
    {},
    'Application in progress',
  );

  const hasErrorStatus =
    status === ShipmentCommercialInvoiceDetailStatus.VALIDATION_FAILED ||
    status === ShipmentCommercialInvoiceDetailStatus.REJECTED;
  const isInProgress =
    status === ShipmentCommercialInvoiceDetailStatus.IN_PROGRESS;

  if (!status) return null;

  let color: string | undefined;
  let label = '1CC';
  if (hasErrorStatus) {
    color = 'red';
    label = validationFailedMessage;
  } else if (isInProgress) {
    color = 'blue';
    label = inProgressMessage;
  }

  return (
    <div>
      <Tag color={color}>{label}</Tag>
    </div>
  );
};

export default ShipmentStatus;
